import { DynamicContentComponentMap } from '@x/content/render';

export const SHOP_CONTENT_DYNAMIC_COMPONENTS: DynamicContentComponentMap = {
  ComponentShopProductListing: () =>
    import('./components/content-product-listing/content-product-listing.module').then(
      (m) => m.ContentProductListingModule,
    ),

  ComponentShopCatalogReel: () =>
    import('./components/catalog-reel/catalog-reel.module').then((m) => m.CatalogReelModule),
};
